// Validadores compartidos para formularios del modulo RBAC
// Debe mantenerse en sincronia con helpers/validators.js del backend

// Password: 6-12 caracteres, al menos 1 mayuscula, 1 minuscula, 1 numero y 1 caracter especial
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]).{6,12}$/;

// Telefono venezolano: 11 digitos, prefijos 0412, 0414, 0416, 0422, 0424, 0426
export const PHONE_VE_REGEX = /^0(412|414|416|422|424|426)\d{7}$/;

// Username: minimo 5 caracteres alfanumericos + . _ -
export const USERNAME_REGEX = /^[a-zA-Z0-9._-]{5,}$/;

// Email: formato estandar
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export function isValidPassword(pwd: string): boolean {
  return typeof pwd === 'string' && PASSWORD_REGEX.test(pwd);
}

export function isValidPhoneVE(phone: string): boolean {
  return typeof phone === 'string' && PHONE_VE_REGEX.test(phone);
}

export function isValidUsername(username: string): boolean {
  return typeof username === 'string' && USERNAME_REGEX.test(username);
}

export function isValidEmail(email: string): boolean {
  return typeof email === 'string' && EMAIL_REGEX.test(email);
}

// Mensajes de error estandar
export const VALIDATION_MESSAGES = {
  required: 'Este campo es obligatorio',
  nameRequired: 'El nombre es obligatorio',
  lastNameRequired: 'El apellido es obligatorio',
  usernameRequired: 'El nombre de usuario es obligatorio',
  usernameInvalid: 'Debe tener al menos 5 caracteres (letras, numeros, . _ -)',
  passwordRequired: 'La contrasena es obligatoria',
  passwordInvalid: 'Debe tener 6-12 caracteres con mayuscula, minuscula, numero y caracter especial',
  emailInvalid: 'El correo electronico no es valido',
  phoneInvalid: 'Debe tener 11 digitos y empezar con 0412, 0414, 0416, 0422, 0424 o 0426',
  phoneOnlyNumbers: 'Solo se permiten numeros',
  deactivationReasonRequired: 'Debe seleccionar un motivo de inactivacion',
  deactivationNoteRequired: 'Debe describir el motivo'
};

// Motivos de inactivacion
export const DEACTIVATION_REASONS = [
  { value: 'REPOSO', label: 'Reposo' },
  { value: 'VACACIONES', label: 'Vacaciones' },
  { value: 'RENUNCIA', label: 'Renuncia o egreso' },
  { value: 'OTRO', label: 'Otro (especificar)' }
];

// Sanitizadores
export function sanitizePhone(value: string): string {
  // Solo dejar numeros, maximo 11 caracteres
  return (value || '').replace(/[^0-9]/g, '').slice(0, 11);
}

export function sanitizePassword(value: string, maxLength: number = 12): string {
  return (value || '').slice(0, maxLength);
}
